export default __webpack_public_path__ + "static/media/oa_4.a835d9b5.mp3";